

const serverPrivateKey = ``


export default {
    // CLIENT_PUBLIC_KEY: clientPublicKey,
    CLIENT_PUBLIC_KEY: process.env.VUE_APP_CLIENT_PUBLIC_KEY,
    // CLIENT_PUBLIC_KEY: process.env.VUE_APP_CLIENT_PUBLIC_KEY_FOR_DEV,
    SERVER_PRIVATE_KEY: serverPrivateKey,
    URI_CLIENT_PUBLIC_KEY: process.env.VUE_APP_URI_CLIENT_PUBLIC_KEY
}

